import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid2";
import TextField from "@mui/material/TextField";
import { useFormik } from "formik";
import countries from "i18n-iso-countries";
import { FC, useMemo } from "react";

import Autocomplete from "@mui/material/Autocomplete";
import Paper from "@mui/material/Paper";
import { AccountBillingFormValues } from ".";

interface CountriesSelectFieldProps {
	form: ReturnType<typeof useFormik<AccountBillingFormValues>>;
	name: string;
	label: string;
	md?: number;
}

export const CountriesSelectField: FC<CountriesSelectFieldProps> = ({
	form,
	name,
	label,
	md = 6,
}) => {
	const { getFieldProps } = form;

	const options = useMemo(
		() =>
			Object.entries(countries.getNames("en")).map((entry) => ({
				id: entry[0],
				name: entry[1],
				value: entry[0],
			})),
		[],
	);

	return (
		<Grid
			size={{
				md: md,
				xs: 12,
			}}>
			<FormControl fullWidth>
				<Autocomplete
					{...getFieldProps(name)}
					value={getFieldProps(name).value || null}
					disableClearable
					size="small"
					onChange={(_, value) => form.setFieldValue(name, value?.id)}
					PaperComponent={(props) => (
						<Paper
							variant="outlined"
							{...props}
						/>
					)}
					renderInput={(params) => (
						<TextField
							{...params}
							sx={{
								".MuiOutlinedInput-root.MuiInputBase-sizeSmall": {
									py: "5px",
								},
							}}
							label={label}
							error={!!form.touched.country && !!form.errors.country}
						/>
					)}
					options={options}
					getOptionLabel={(option) =>
						options.find(
							(o) => o.id === (typeof option === "string" ? option : option.id),
						)?.name ?? "UNKNOWN COUNTRY"
					}
					getOptionKey={(option) => option.id}
					isOptionEqualToValue={(option, value) => option.id === value}
				/>
			</FormControl>
		</Grid>
	);
};
